<template>
  <!-- The brand accent inside a headline: "Generate *color palettes* from any
       website". Inline, so it wraps with the words around it. -->
  <span class="bg-gradient-to-r from-violet-500 via-blue-50 to-indigo-400 bg-clip-text text-transparent"><slot /></span>
</template>
